// Move trust line above ATC button
document.addEventListener('DOMContentLoaded', function() {
  var trust = document.querySelector('p.product-trust-line');
  var atc = document.getElementById('createsize-div');

  if (!trust || !atc) return;

  // Hide original in place (override inline style)
  trust.setAttribute('style', 'display:none!important');

  // Move it inside the ATC div above the button
  trust.setAttribute('style', 'display:block;text-align:center;font-size:11px;font-weight:700;color:#555;margin:0 0 8px 0;padding:0;width:100%;letter-spacing:0.01em;');
  atc.insertBefore(trust, atc.firstChild);
});
